import { SegmentedControl as MantineSegmentedControl, SegmentedControlProps } from "@mantine/core";
import { type FC } from "react";
import styles from "./styles.module.css";

export const SegmentedControls: FC<SegmentedControlProps> = (props) => {
  return (
    <MantineSegmentedControl
      {...props}
      classNames={{
        root: styles.root,
        control: styles.control,
        label: styles.label,
      }}
      size="xs"
    />
  );
};

export default SegmentedControls;
